import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, Stack, Typography, useMediaQuery,Box } from '@mui/material';

// project imports
import AuthWrapper1 from '../../Component/AuthWrapper1';
import AuthCardWrapper from '../../Component/AuthCardWrapper';
import AuthLogin from './AuthLogin';
// import Logo from '../../../../ui-component/Logo';
// import AuthFooter from '../../../../ui-component/cards/AuthFooter';

// assets

// ================================|| AUTH3 - LOGIN ||================================ //

const Login = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AuthWrapper1>
      <div className='login-background' style={{minHeight:"100vh"}} >
      <Grid  container  className=' g-0' >
        <Grid md={6} >
          <Box sx={{ display: "flex", justifyContent: { xs: "center", md: 'center' } ,mt:{xs:2,md:3}}}  >
            <a href='https://getbettertransportation.com/' > <img src='/driver_forms/assets/images/output-onlinepngtools.png' className='logo' /></a>

          </Box>
          <Box mt={8} sx={{mb:{xs:0,md:5}}} >
            <Typography className='main-title' sx={{ fontSize: 57, textAlign: "center", fontWeight: "bolder", color: "#FFF", letterSpacing: 5, lineHeight: 1, textTransform: "uppercase" }} >Get the best medical transportation in new york!</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} direction="column" display={"flex"} sx={{justifyContent:{xs:"start",md:"center"}}}  alignItems={"center"} >
          
            
              <AuthCardWrapper>
                <Grid container spacing={1} alignItems="center" justifyContent="center">

                  <Grid item xs={12}>
                    <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                      <Grid item>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                          <Typography color={"#92c323"} gutterBottom variant={matchDownSM ? 'h5' : 'h4'}>
                            Login
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <AuthLogin />
                  </Grid>
                </Grid>
              </AuthCardWrapper>
           
          
        </Grid>
      </Grid>
      </div>
    </AuthWrapper1>
  );
};

export default Login;
